/**
 * Castle & Key Grounds Map
 * Handles marker selection and content card navigation.
 */
if (!customElements.get('ck-grounds-map')) {
  class CKGroundsMap extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.markers = this.querySelectorAll('[data-marker-index]');
      this.cardItems = this.querySelectorAll('[data-card-item]');
      this.cardImages = this.querySelectorAll('[data-card-image]');
      this.cardNum = this.querySelector('[data-card-num]');
      this.total = this.markers.length;

      if (!this.total) return;

      this.markers.forEach(function (marker) {
        marker.addEventListener('click', this.onMarkerClick.bind(this));
      }.bind(this));

      var prevBtn = this.querySelector('[data-nav="prev"]');
      var nextBtn = this.querySelector('[data-nav="next"]');
      if (prevBtn) prevBtn.addEventListener('click', this.prev.bind(this));
      if (nextBtn) nextBtn.addEventListener('click', this.next.bind(this));

      // Touch swipe support
      this.touchStartX = 0;
      this.addEventListener('touchstart', function (e) {
        this.touchStartX = e.touches[0].clientX;
      }.bind(this), { passive: true });

      this.addEventListener('touchend', function (e) {
        var diff = this.touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          if (diff > 0) this.next();
          else this.prev();
        }
      }.bind(this), { passive: true });
    }

    onMarkerClick(e) {
      var index = parseInt(e.currentTarget.getAttribute('data-marker-index'), 10);
      this.goTo(index);
    }

    prev() {
      this.goTo(this.activeIndex === 0 ? this.total - 1 : this.activeIndex - 1);
    }

    next() {
      this.goTo(this.activeIndex === this.total - 1 ? 0 : this.activeIndex + 1);
    }

    goTo(index) {
      if (index === this.activeIndex) return;

      this.markers[this.activeIndex].classList.remove('is-active');
      this.markers[index].classList.add('is-active');

      if (this.cardItems[this.activeIndex]) this.cardItems[this.activeIndex].classList.remove('is-active');
      if (this.cardItems[index]) this.cardItems[index].classList.add('is-active');

      if (this.cardImages[this.activeIndex]) this.cardImages[this.activeIndex].classList.remove('is-active');
      if (this.cardImages[index]) this.cardImages[index].classList.add('is-active');

      var num = (index + 1).toString();
      if (num.length < 2) num = '0' + num;
      if (this.cardNum) this.cardNum.textContent = num;

      this.activeIndex = index;
      this.setAttribute('data-active', index);
    }
  }

  customElements.define('ck-grounds-map', CKGroundsMap);
}
